import Vue from 'vue'
import AuthService from '../auth/AuthService'
import Router from 'vue-router'
import store from '@/store'
import Dash from '@/components/Dash'
import Files from '@/components/Files'
import Start from '@/components/Start'
import Login from '@/components/Login'
import Callback from '@/components/Callback'
import Create from '@/components/Create'
import Splash from '@/components/Splash'
import Viewer from '@/components/Viewer'
import Nested from '@/components/Nested'
import Onboard from '@/components/Onboard'
import Trial from '@/components/Trial'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/dash',
      component: Dash,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'Dash',
          component: Files,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'magic/:jobPath',
          name: 'Magic',
          // props: true,
          component: Start,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'create/:id/:jobPathKey',
          // props: true,
          name: 'ContinueCreateJob',
          component: Create,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'create/:id',
          // props: true,
          name: 'CreateJob',
          component: Create,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/create/:id',
          name: 'NestedCreateById',
          component: Create,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/create/',
          name: 'NestedCreate',
          component: Create,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/magic/',
          name: 'NestedMagic',
          component: Start,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/magic/:id',
          name: 'NestedMagicById',
          component: Start,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/',
          name: 'NestedQuantity',
          component: Nested,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'nested/:id',
          name: 'NestedQuantityById',
          component: Nested,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/viewer/:type/:id',
      name: 'ThreeJSViewer',
      // props: true,
      component: Viewer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/onboarding',
      name: 'Onboard',
      component: Onboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/splash',
      name: 'Splash',
      component: Splash,
      alias: '/logout'
    },
    {
      path: '*',
      redirect: '/splash'
    }
  ]
})

export const routerTrials = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Trial',
      component: Trial
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.dispatch('getConfig')
  if (store.state.auth === null) {
    const auth = new AuthService()

    store.commit('SET_AUTH', auth)
    auth.authNotifier.on('authChange', authState => {
      store.commit('SET_AUTHENTICATED', authState.authenticated)
    })
  }
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('id_token')
    const siemensId = localStorage.getItem('siemens_id')
    const lastLogin = localStorage.getItem('last_login')
    const tokenNx = to.query.token
    if (tokenNx) {
      store.commit('user/SET_TOKEN', tokenNx)
      return next()
    } else if (token && siemensId) {
      const expiration = JSON.parse(localStorage.getItem('expires_at'))
      if (expiration > new Date().getTime()) {
        store.commit('user/SET_TOKEN', token)
        store.commit('user/SET_SIEMENS_ID', siemensId)
        store.commit('SET_AUTHENTICATED', store.state.auth.authenticated)

        if (lastLogin) {
          store.commit('user/SET_LAST_LOGIN', JSON.parse(lastLogin))
        }

        const createAndLoadUser = () => {
          return store.dispatch('user/createUser')
            .then(() => {
              return store.dispatch('user/loadUser')
            })
        }

        // check onboard status. Load user if he wasn't loaded
        if (store.state.user.isOnboard === null) {
          return store.dispatch('user/loadUser')
            .then(() => {
              // create the user if AppSync doesn't contain
              if (!store.state.user.loaded) return createAndLoadUser()
            })
            .then(() => {
              if (to.name === 'Onboard') {
                store.state.user.isOnboard ? next('/dash') : next()
              } else {
                store.state.user.isOnboard ? next() : next('/onboarding')
              }
            })
            .catch(() => next('/splash'))
        } else {
          if (to.name === 'Onboard') {
            return store.state.user.isOnboard ? next('/dash') : next()
          } else {
            return store.state.user.isOnboard ? next() : next('/onboarding')
          }
        }
      }
    }
    return next('/splash')
  }

  next()
})

routerTrials.beforeEach((to, from, next) => {
  store.dispatch('getConfig')
  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js